export const REQ_WAREHOUSES_SUCCESS = "REQ_WAREHOUSES_SUCCESS"